import styled from 'styled-components';

export const Term = styled.dt`
  float: left;
  font-weight: var(--bold);
  margin-right: 6px;
`;

export const Definition = styled.dd`
  align-items: center;
  display: flex;
`;

export const DescriptiveList = styled.dl`
  color: var(--descriptive-list-text);
  font-size: var(--regular);

  ${Definition}:not(:last-of-type),
  ${Term}:not(:last-of-type) {
    margin-bottom: 12px;
  }
`;
